import Rest from '../rest'
import axios  from 'axios'

/******************************************************************************
 *  Users
 *****************************************************************************/

/**
 * @type {User}
 */
export default class User extends Rest {

    constructor() {
        super('/users')
    }

    me(token) {
        return this.http.get(
            this.resource + '/me?q=&per_page=10000',
            {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }
        )
    }
    cleanTags(str) {
        return str.replace(/(<([^>]+)>)/ig, '');
    }
    transfer(url, id, payload) {
        return this.http.delete(this.constructor.normalize(this.resource, url, id), {data: payload})
    }

    dataCleaner(dirtyData) {
        let data = dirtyData;

        for (var prop in data) {
            if (typeof (data[prop]) === "string") {
                data[prop] = this.cleanTags(data[prop]);
            }

            if (
                data[prop] === null      ||
                data[prop] === undefined ||
                data[prop] === "null"
            ){
                data[prop] = ""
            }
        }

        return data;
    }  
    read() {
        return axios.get(this.prefix + 'users')
    }

    readDynamics() {
        return this.getAll('/groups/dynamics')
    }

    updateDynamicUser(user_id, data) {
        return this.http.post(`users/groups/dynamics/${user_id}`, data)
    }

    createDynamicUser(data) {
        return this.http.post(`users/groups/dynamics/`, data)
    }

    deleteDynamicUser(id) {
        return this.http.delete(`users/groups/dynamics/${id}`)
    }

    groups(){
        return super.get('groups/dynamics', '', '')
    }

    readPermissions() {
        return this.getAll('/load/permissions')
    }

    readFilters() {
        return axios.get(this.prefix + 'users-filters')
    }

    getPoints(user_id) {
        return this.http.get(`balances/value/user/${user_id}/true`)
    }

    getAllPoints(user_id) {
        return this.http.get(`balances/${user_id}`)
    }

    simplifiedUsers(){
        return this.http.get(`simplifiedusers/true`)
    }

    changeStatus(url, id, formData = {}){
        return this.http.put(this.constructor.normalize('users/', id + '/status'))
    }

    async bulkStatusChange(usersData){
        const {data} = await this.createV2('/statuses', usersData)
        return data
    }

}